import styled, { css } from 'styled-components';
import Box from '../../../../_shared/components/Box';
import applyResponsiveVdpStyles from '../../../../_shared/helpers/applyResponsiveVdpStyles';
import { TradeState } from '../../../../_shared/types/trade';
import isOmpPlatform from '../../../../_shared/utils/isOmpPlatform';

const isOmp = isOmpPlatform();
/**
 * Variant Definitions
 */
const StyledSummaryMiniVdpVariants = {
  overview: css`
    order: 1;
    height: auto;
    padding: 0;
    padding-top: ${({ isCSU }) => isCSU && '30px'};
    justify-content: flex-end;
  `
};

const StyledSummaryVariants = {
  mini: css`
    ${({ variant }) => StyledSummaryMiniVdpVariants[variant]}
  `,
  [TradeState.pending]: css`
    padding: 12px 18px;
    width: 100%;
    ${({ isSelling, theme }) =>
      !isSelling &&
      `
    border-bottom: 1px solid ${theme.COLORS.NEUTRAL_60};
    `}
  `
};

const StyledSummaryInfoWrapperVariants = {
  timer: css`
    width: auto;

    & > div {
      margin-right: 18px;
    }
  `,
  mini: css`
    width: 100%;
  `
};

const StyledActiveTimerVariants = {
  mini: css`
    margin-right: 18px;
  `,
  expanded: css`
    display: none;
  `
};

export const StyledSummary = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px 18px;
  ${({ tradeState }) => StyledSummaryVariants[tradeState]};
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledSummaryVariants.mini
    })}
`;

export const StyledActiveTimer = styled.div`
  ${({ theme, variant }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledActiveTimerVariants.mini,
      expanded: variant !== 'modal' && StyledActiveTimerVariants.expanded
    })}
    margin-left: ${({ variant }) => variant === 'modal' && '130px'};
    display: flex;
`;

const StyledFullHistoryLinkVariants = {
  [TradeState.pending]: css`
    margin-left: auto;
  `
};

export const StyledFullHistoryLink = styled.a`
  && {
    color: ${({ theme }) => theme.COLORS.BASE_INVERTED} !important;
    text-decoration: ${isOmp ? 'none' : 'underline'};
    &:visited {
      color: ${({ theme }) => theme.COLORS.TERTIARY};
    }
    ${({ tradeState }) => StyledFullHistoryLinkVariants[tradeState]};
  }
`;

export const StyledSummaryInfoWrapper = styled(Box)`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledSummaryInfoWrapperVariants.mini
    })}

  ${props => StyledSummaryInfoWrapperVariants[props.variant]};
`;

export const StyledPendingTopBidComponent = styled.div`
  min-width: 135px;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL}
  line-height: 14px;
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};

  & > span {
    color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  }
`;

export const BidInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const BidInfoTop = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
`;

export const BidInfoDetails = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  border-top: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_60};
  margin-top: 11px;
  padding-top: 8px;
`;

export const StyledFloorPriceLabel = styled.p`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  line-height: 14px;
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  margin: 0px;
`;

export const StyledFloorPrice = styled.p`
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE_SIZE};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  line-height: 18px;
  margin: 0px;
`;

export const PendingTopBid = styled.p`
  margin: 0 0 9px 0;
`;
